// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard-page-board .btn-group, .leaderboard-page-rules .btn-group {
  padding: 10px 0 10px 0;
  display: block;
  text-align: center; }
  .leaderboard-page-board .btn-group .btn, .leaderboard-page-rules .btn-group .btn {
    padding: 0 35px 0 35px; }
  .leaderboard-page-board .btn-group .btn-light, .leaderboard-page-rules .btn-group .btn-light {
    border: 1px solid #606060;
    width: 50%; }
  .leaderboard-page-board .btn-group .btn-secondary, .leaderboard-page-rules .btn-group .btn-secondary {
    background-color: #606060;
    width: 50%; }

.leaderboard-page-board .noResults, .leaderboard-page-rules .noResults {
  margin-top: 1em;
  text-align: center;
  font-weight: bold; }

.leaderboard-page-board .leaderboard-user {
  position: relative; }
  .leaderboard-page-board .leaderboard-user .user-list {
    padding: 10px 0 10px 10px; }
    .leaderboard-page-board .leaderboard-user .user-list .user-info {
      width: 63%; }
    .leaderboard-page-board .leaderboard-user .user-list .user-icons {
      display: none; }
  .leaderboard-page-board .leaderboard-user .hasTrophy {
    margin-top: -10px;
    font-size: 1.1em; }
  .leaderboard-page-board .leaderboard-user .col-2 {
    font-weight: bolder;
    margin-top: auto;
    margin-bottom: 20px; }
  .leaderboard-page-board .leaderboard-user hr {
    margin: 0; }
  .leaderboard-page-board .leaderboard-user :hover {
    cursor: default; }
  .leaderboard-page-board .leaderboard-user .leaderboard-rank {
    position: absolute;
    font-size: 1.1em;
    padding-right: 10px;
    right: 0%;
    top: 34%;
    text-align: center; }

.leaderboard-page-rules .rules-list-header {
  color: #4330ff;
  font-size: 20px;
  margin-bottom: 15px;
  text-align: left;
  width: 100%; }

.leaderboard-page-rules .rules-list {
  padding-left: 10px;
  font-weight: bolder; }
  .leaderboard-page-rules .rules-list .col-2 {
    text-align: right;
    padding-right: 25px; }
`, "",{"version":3,"sources":["webpack://./src/components/Leaderboard/leaderboard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,yBAAyB;IACzB,UAAU,EAAE;EACd;IACE,yBAAyB;IACzB,UAAU,EAAE;;AAEhB;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB,EAAE;;AAErB;EACE,kBAAkB,EAAE;EACpB;IACE,yBAAyB,EAAE;IAC3B;MACE,UAAU,EAAE;IACd;MACE,aAAa,EAAE;EACnB;IACE,iBAAiB;IACjB,gBAAgB,EAAE;EACpB;IACE,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB,EAAE;EACvB;IACE,SAAS,EAAE;EACb;IACE,eAAe,EAAE;EACnB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,kBAAkB,EAAE;;AAExB;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW,EAAE;;AAEf;EACE,kBAAkB;EAClB,mBAAmB,EAAE;EACrB;IACE,iBAAiB;IACjB,mBAAmB,EAAE","sourcesContent":[".leaderboard-page-board .btn-group, .leaderboard-page-rules .btn-group {\n  padding: 10px 0 10px 0;\n  display: block;\n  text-align: center; }\n  .leaderboard-page-board .btn-group .btn, .leaderboard-page-rules .btn-group .btn {\n    padding: 0 35px 0 35px; }\n  .leaderboard-page-board .btn-group .btn-light, .leaderboard-page-rules .btn-group .btn-light {\n    border: 1px solid #606060;\n    width: 50%; }\n  .leaderboard-page-board .btn-group .btn-secondary, .leaderboard-page-rules .btn-group .btn-secondary {\n    background-color: #606060;\n    width: 50%; }\n\n.leaderboard-page-board .noResults, .leaderboard-page-rules .noResults {\n  margin-top: 1em;\n  text-align: center;\n  font-weight: bold; }\n\n.leaderboard-page-board .leaderboard-user {\n  position: relative; }\n  .leaderboard-page-board .leaderboard-user .user-list {\n    padding: 10px 0 10px 10px; }\n    .leaderboard-page-board .leaderboard-user .user-list .user-info {\n      width: 63%; }\n    .leaderboard-page-board .leaderboard-user .user-list .user-icons {\n      display: none; }\n  .leaderboard-page-board .leaderboard-user .hasTrophy {\n    margin-top: -10px;\n    font-size: 1.1em; }\n  .leaderboard-page-board .leaderboard-user .col-2 {\n    font-weight: bolder;\n    margin-top: auto;\n    margin-bottom: 20px; }\n  .leaderboard-page-board .leaderboard-user hr {\n    margin: 0; }\n  .leaderboard-page-board .leaderboard-user :hover {\n    cursor: default; }\n  .leaderboard-page-board .leaderboard-user .leaderboard-rank {\n    position: absolute;\n    font-size: 1.1em;\n    padding-right: 10px;\n    right: 0%;\n    top: 34%;\n    text-align: center; }\n\n.leaderboard-page-rules .rules-list-header {\n  color: #4330ff;\n  font-size: 20px;\n  margin-bottom: 15px;\n  text-align: left;\n  width: 100%; }\n\n.leaderboard-page-rules .rules-list {\n  padding-left: 10px;\n  font-weight: bolder; }\n  .leaderboard-page-rules .rules-list .col-2 {\n    text-align: right;\n    padding-right: 25px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
